import { useEffect, useRef, useState } from "react";
import { LayoutGrid, Plus } from "lucide-react";

import { BlobShipMark } from "@/components/BlobShipMark";
import { BLOBSHIP_APP_URL } from "@/lib/env";
import { cn } from "@/lib/utils";

/**
 * The "Tools on the belt" launcher — the cross-product switcher in the topbar.
 * BlobShip is the one live tool today; the dashed tile reserves room for the next.
 */
export function AppLauncher() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="Tools on the belt"
        className={cn(
          "inline-flex size-9 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground",
          open && "bg-secondary text-foreground",
        )}
      >
        <LayoutGrid className="size-5" />
      </button>

      {open && (
        <div className="absolute right-0 top-11 z-50 w-[300px] rounded-lg border border-border bg-popover p-3 shadow-glow">
          <div className="px-1 pb-2 font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
            Tools on the belt
          </div>
          <div className="grid grid-cols-2 gap-2">
            <a
              href={BLOBSHIP_APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col gap-2 rounded-md border border-border bg-card p-3 transition-colors hover:border-primary/50"
            >
              <span className="flex size-8 items-center justify-center rounded-md bg-primary/10 text-primary">
                <BlobShipMark size={18} />
              </span>
              <span className="text-sm font-semibold">
                Blob<span className="text-primary">Ship</span>
              </span>
              <span className="text-[11px] text-muted-foreground">file shipping</span>
            </a>
            <div className="flex flex-col items-center justify-center gap-1.5 rounded-md border border-dashed border-border p-3 text-muted-foreground">
              <Plus className="size-4" />
              <span className="text-[11px]">more coming</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
